import { OPERA_COUNTRY_CODES } from './country-codes';

export const getCountryName = (operaCode: string) =>
  OPERA_COUNTRY_CODES.find((country) => operaCode === country.code)?.label;
